import React, { useEffect, useState, useContext } from "react";
import "./TaskSummary.css";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import check from "../../../assets/check.svg";
import file from "../../../assets/file.svg";
import medicines from "../../../assets/medicines.svg";
import box from "../../../assets/box.svg";
import { getSuccessToast, getErrorToast } from "../../../toast";
import { ReactSession } from "react-client-session";
import FormContext from "../../../context/FormContext";

const TaskSummary = ({
  setClaimFilter
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [summary, setSummary] = useState({});
  const [userList, setUserList] = useState([]);
  const [filter, setFilter] = useState({
    startDate: getFirstDayOfMonth(),
    endDate: maxfromat(),
    operator: "all",
  });
  const { setFilterEntry } = useContext(FormContext);
  const [completeBox, setCompleteBox] = useState([]);
  const [inCompleteBox, setInCompleteBox] = useState([]);
  const [totalBox, setTotalBox] = useState([]);

  useEffect(() => {
    const username = ReactSession.get("username");
    axiosPrivate
      .get("/dashboard/filterby_defult/", {
        params: {
          operator: username,
        },
      })
      .then((response) => {
        if (typeof response.data.data === "object") {
          setSummary(response.data.data);
          setCompleteBox(response.data.data["complete_box_data"]);
          setInCompleteBox(response.data.data["incomplete_box_data"]);
          setTotalBox(response.data.data["total_box_data"]);
        } else {
          setSummary({
            total_box: "0",
            compile_box: "0",
            incompile_box: "0",
            total_medicine: "0",
          });
          getSuccessToast("No Information found");
        }
      });
    axiosPrivate
      .get(`/dashboard/user-list/`)
      .then((res) => {
        setUserList(res.data["username"]);
      })
      .catch((err) => {
        getErrorToast("No Internet connection Found");
      });
  }, []);

  const handleFilter = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const filterClick = () => {
    if (filter["endDate"] !== null && filter["operator"] !== "") {
      const formDate = new FormData();
      formDate.append(
        "start_date",
        filter["startDate"].toLocaleString({ timeZone: "Asia/Kolkata" })
      );
      formDate.append(
        "end_date",
        filter["endDate"].toLocaleString({ timeZone: "Asia/Kolkata" })
      );
      formDate.append(
        "operator",
        filter["operator"].toLocaleString({ timeZone: "Asia/Kolkata" })
      );
      axiosPrivate
        .post("/dashboard/filterby_datename/", formDate)
        .then((response) => {
          if (typeof response.data.data === "object") {
            setSummary(response.data.data);
            setCompleteBox(response.data.data["complete_box_data"]);
            setInCompleteBox(response.data.data["incomplete_box_data"]);
            setTotalBox(response.data.data["total_box_data"]);
            getSuccessToast("Filter Successful");
          } else {
            setSummary({
              total_box: "N/A",
              compile_box: "N/A",
              incompile_box: "N/A",
              total_medicine: "N/A",
            });
            getSuccessToast("No Information found");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      getErrorToast("Select all Fields");
    }
  };

  function maxfromat() {
    let date = new Date();
    let year = date.getFullYear();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    if (month.toString().length === 1) {
      month = `0${month}`;
    }
    if (day.toString().length === 1) {
      day = `0${day}`;
    }
    return `${year}-${month}-${day}`;
  }
  function getFirstDayOfMonth() {
    const d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    if (month.toString().length === 1) {
      month = `0${month}`;
    }
    return `${year}-${month}-01`;
  }

  const CompleteChangeHandler = () => {
    setFilterEntry(true);
    setClaimFilter(completeBox);
  };

  const InCompleteChangeHandler = () => {
    setFilterEntry(true);
    setClaimFilter(inCompleteBox);
  };
  const totalBoxChangeHandler = () => {
    setFilterEntry(true);
    setClaimFilter(totalBox);
  };

  return (
    <div className="task-container">
      <section className="task-container-header">
        <p className="task-container-header-title">Task Summary</p>
        <input
          className="task-container-s-6-date-1 task-container-s-6-input"
          type="date"
          name="startDate"
          id=""
          value={filter["startDate"]}
          max={filter["endDate"] === null ? maxfromat() : filter["endDate"]}
          onChange={handleFilter}
        />
        <input
          className="task-container-s-6-date-2 task-container-s-6-input "
          type="date"
          name="endDate"
          id=""
          value={filter["endDate"]}
          min={filter["startDate"]}
          max={maxfromat()}
          onChange={handleFilter}
        />
        <select
          name="operator"
          className="task-container-s-6-search task-container-s-6-input"
          onChange={handleFilter}
        >
          <option value="all">All Operator</option>
          {userList.map((user) => {
            return (
              <option key={user} value={user}>
                {user}
              </option>
            );
          })}
        </select>
        <section className="task-container-s-6-button-section">
          <button className="task-container-s-6-button" onClick={filterClick}>
            Filter
          </button>
        </section>
      </section>

      <section
        className="task-container-section task-container-s-2"
        onClick={CompleteChangeHandler}
      >
        <div>
          <img className="task-container-img" src={check} alt="/" />
        </div>
        <br />
        <h4 className="task-container-number">{summary["compile_box"]}</h4>
        <small className="task-container-content">Claims</small>
        <p className="task-container-details">Completed</p>
      </section>

      <section
        className="task-container-section task-container-s-3"
        onClick={InCompleteChangeHandler}
      >
        <div>
          <img className="task-container-img " src={file} alt="/" />
        </div>
        <br />

        <h4 className="task-container-number">{summary["incompile_box"]}</h4>
        <small className="task-container-content">Claims</small>
        <p className="task-container-details">Incomplete</p>
      </section>

      <section className="task-container-section task-container-s-4">
        <div>
          <img className="task-container-img " src={medicines} alt="/" />
        </div>
        <br />

        <h4 className="task-container-number">{summary["total_medicine"]}</h4>
        <small className="task-container-content">Medicine</small>
        <p className="task-container-details">Count</p>
      </section>

      <section
        className="task-container-section task-container-s-5"
        onClick={totalBoxChangeHandler}
      >
        <div>
          <img className="task-container-img " src={box} alt="/" />
        </div>
        <br />
        <h4 className="task-container-number">{summary["total_box"]}</h4>
        <small className="task-container-content">Stockist</small>
        <p className="task-container-details">Claims</p>
      </section>
    </div>
  );
};

export default TaskSummary;
